import {
  AutoPayIcon,
  BillingIcon,
  DashboardIcon,
  DownloadIcon,
  UserProfileIcon,
  LeaderBoardIcon,
  BookIcon,
  LiveChatIcon,
  AffiliatesIcon,
} from '@features/ui/icons';

import { type SidebarData } from '../types';

export const sidebarData: SidebarData = {
  navItems: [
    {
      icon: DashboardIcon,
      title: 'dashboardMenuItems.dashboard',
      url: '/',
    },
    {
      icon: AffiliatesIcon,
      title: 'dashboardMenuItems.affiliates',
      url: '/affiliates',
      items: [
        // {
        //   title: 'dashboardMenuItems.payouts',
        //   url: '/affiliates/payouts',
        // },
        {
          title: 'dashboardMenuItems.payoutMethods',
          url: '/affiliates/payout-method',
        },
        {
          title: 'dashboardMenuItems.bannerAndLinks',
          url: '/affiliates/banner-and-links',
        },
      ],
    },
    {
      icon: BillingIcon,
      title: 'dashboardMenuItems.billing',
      url: '/billing',
    },
    {
      icon: AutoPayIcon,
      title: 'dashboardMenuItems.payoutRequest',
      url: '/payout-request',
    },
    {
      icon: DownloadIcon,
      title: 'dashboardMenuItems.downloads',
      url: '/download',
    },
    {
      icon: UserProfileIcon,
      title: 'dashboardMenuItems.profile',
      url: '/profile',
    },
    {
      icon: LeaderBoardIcon,
      title: 'dashboardMenuItems.leaderboard',
      url: '/leaderboard',
    },
    {
      icon: BookIcon,
      title: 'dashboardMenuItems.knowledgeBase',
      url: '/knowledge-base',
    },
    {
      icon: LiveChatIcon,
      title: 'dashboardMenuItems.askAlise',
      url: 'https://alise.io/leeloo-traders',
    },
  ],
};
